import React, { Component } from 'react';
import * as firebase from "firebase";
import {BrowserRouter as Router,
  Route, Switch} from 'react-router-dom'
import 'firebase/firestore'
import GoogleAnalytics from 'react-ga';
import ReactDOM from 'react-dom';


// pages
import About      from './pages/About'
import Artist     from './pages/Artist'
import Artists    from './pages/Artists'
import Artwork    from './pages/Artwork'
import Collectors from "./pages/Collectors";
import Contact   from './pages/Contact'
import Home       from './pages/Home'
import Login      from './pages/Login'
import Profile    from "./pages/Profile";
import Register   from './pages/Register'
import Settings   from './pages/Settings'

// components
import Header from './Components/Header'
import Footer from "./Components/Footer";
import ComingSoon from "./pages/ComingSoon";


GoogleAnalytics.initialize('UA-31709329-1');


export const version = '0.0.19';

let config = {
  apiKey: "AIzaSyBad29dx1DDjmonoezJh_PQHwh4rvItfTk",
  authDomain: "zoetrove.firebaseapp.com",
  databaseURL: "https://zoetrove.firebaseio.com",
  projectId: "zoetrove",
  storageBucket: "zoetrove.appspot.com",
  messagingSenderId: "1037906340500"
};

//the root app just in case we need it
export const firebaseApp = firebase.initializeApp(config);

export const firestoredb = firebase.firestore();
export const db = firebase.database();
export const auth = firebaseApp.auth(); //the firebase auth namespace

export const isAuthenticated = () => {
 // console.log(auth.currentUser)
  return !!auth.currentUser;
}

export const userData = () => {
  console.log("userData");
  console.log("userData: " + this.state.userData);
  if (this.state && this.state.userData) {
    return this.state.userData
  }
  return "no data";
}

export const isAdmin = () => {
  console.log("isAdmin");

  if (!auth.currentUser) {
    console.log("isAdmin: no current user (false)");
    return false;
  }
  if (this.state && this.state.userData) {
    console.log("isAdmin: return true");
    return !!this.state.userData.isAdmin
  }
  console.log("isAdmin: no state or user data (false)");
  return false;
}

export const isAnonymous = () => {
  if (!auth.currentUser) {
    return false;
  }
  return !!auth.currentUser.isAnonymous;
}

export const isRealUser = () => {
  if (isAuthenticated() && !auth.currentUser.isAnonymous) {
    return true;
  }
  return false;
}

export const handleLogout = () => {
  if (isAuthenticated() && !isAnonymous()) {
    auth.signOut().then(function () {
    }).catch(function (error) {
     // TODO: console.log("error: " + error.message)
    });
  }
}



export var isLoading = true;

class App extends Component {

  constructor(props) {
    super(props);

    this.handleResize = this.handleResize.bind(this);


    this.state = {
      error: "none",
      loggedInName: "",
      globalMessage: null,
      globalError: null,
      isBeta: true,
      userData: null,
      navHeight: 50
    };

    auth.onAuthStateChanged(user => {
      if (user) {
        // console.log("onAuthStateChanged logged in");
        isLoading = false;
        this.setState({uid: user.uid});

        var d = new Date();
        db.ref('users/' + user.uid + '/user_data').set({
          lastLogin: d.getTime(),
          email: (isAuthenticated()) ?  auth.currentUser.email : null
        });

        if (!user.isAnonymous) {
          var docRef = firestoredb.collection('users').doc(user.uid);
          docRef.get().then(function(doc) {
            if (doc.exists) {
              this.setState({userData: doc.data()})
              // console.log("Document data:", doc.data());
              docRef.update({
                last_login: firebase.firestore.FieldValue.serverTimestamp()
              })
                .then(function () {
                  //console.log("Document successfully written!");
                })
                .catch(function (error) {
                  //console.error("Error writing document: ", error);
                });

            } else {
              docRef.set({
                providerId: user.providerId,
                uid: user.uid,
                displayName: user.displayName,
                photoURL: user.photoURL,
                email: user.email,
                last_login: firebase.firestore.FieldValue.serverTimestamp(),
                join_date: firebase.firestore.FieldValue.serverTimestamp(),
                isEnabled: true,
                isArtist: false,
                isAdmin: false
              })
                .then(function () {
                  //console.log("Document successfully written!");
                  this.setState({userData: docRef.data()})

                })
                .catch(function (error) {
                 // console.error("Error writing document: ", error);
                });
            }
          }).catch(function(error) {
            //console.log("Error getting document:", error);
          });
        }

      } else {
        // console.log("onAuthStateChanged logged out");
        isLoading = false;
        this.setState({uid: null});

        if (!isAuthenticated()) {
          // console.log("signing in anonymous")
          auth.signInAnonymously().catch(function (error) {
            // console.log("got error");

            // Handle Errors here.
           // var errorCode = error.code;
            var errorMessage = error.message;

            this.setState({error: errorMessage});
            // console.error(error);
          });
        } else {
          // console.log("already logged in");
          // console.log("isAuthenticated: " + isAuthenticated())
          this.setState({loggedInName: auth.currentUser.uid});
        }
      }
    });

  }

   componentWillMount() {
     //console.log("componentWillMount");

    // console.log(window.location.hostname);

     const isBeta = (
       window.location.hostname === 'beta.zoetrove.com'
       || window.location.hostname === 'localhost'
       || window.location.hostname === 'zoetrove-web.s3-website-us-east-1.amazonaws.com');
     this.setState({isBeta: isBeta});
   }

  handleResize(e = null) {
    let navBar = ReactDOM.findDOMNode(this._navbar);
    if (navBar) {
      this.setState({navHeight: ReactDOM.findDOMNode(this._navbar).offsetHeight});
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }



  logPageView() {
      window.scrollTo(0, 0);
        console.log("page view");
        GoogleAnalytics.set({ page: window.location.pathname + window.location.search });
        GoogleAnalytics.pageview(window.location.pathname + window.location.search);
    }

  render() {
    //console.log(this.props);


    if (!this.state.isBeta) {
      return (
        <Router>
          <div>
            {(isLoading)
              ? <div></div>
              : <main style={{paddingTop: 30}}>
                  <Route component={ComingSoon}/>
                </main>
            }
          </div>
        </Router>
      );
    }

    return (
      <Router onUpdate={this.logPageView}>
        <div>
          <Header/>
          {(isLoading)
            ? <div><i className="fa fa-spinner fa-spin fa-3x fa-fw"></i></div>
            : <main style={{paddingTop: this.state.navHeight}}>
                  <Route exact path="/" component={Home}/>
                  <Route path="/about" component={About}/>
                  <Route path="/contact" component={Contact}/>
                  <Route path="/login" component={Login}/>
                  <Route path="/register" component={Register}/>
                  <Route path="/settings" component={Settings}/>
                  <Route exact path="/artists" component={Artists}/>
                  <Switch>
                    <Route exact path="/artist" component={Artist}/>
                    <Route path="/artist/:id" component={Artist}/>
                  </Switch>
                  <Switch>
                    <Route exact path="/profile" component={Profile}/>
                    <Route path="/profile/:id" component={Profile}/>
                  </Switch>
              <Switch>
                <Route exact path="/collectors" component={Collectors}/>
                <Route path="/collectors/:id" component={Profile}/>
              </Switch>
              <Switch>
                <Route exact path="/artwork" component={Artwork}/>
                <Route path="/artwork/:id" component={Artwork}/>
              </Switch>
              </main>
          }
          <Footer/>
        </div>
      </Router>
    );

}
}

export function GotoPage(event, props, page) {
  event.preventDefault();
  props.history.push(page);
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js